import axios from '../core/axios';
import { ApiConstants } from './api-constants';

export type GetBusinessesQueryParamsType = {
  mine?: boolean;
  search?: string;
  category?: string;
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  pageSize?: number;
  refresh?: boolean;
};

export class BusinessesService {
  static getBusinesses = async (params?: GetBusinessesQueryParamsType) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_BUSINESSES.URL(), { params })
    ).data;
  };
  static getBusinessById = async (companyId: string) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_BUSINESS_BY_ID.URL(companyId))
    ).data;
  };
  static addTarget = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.BUSINESSES_API.POST_BUSINESS_TARGET.URL(), payload)
    ).data;
  };
  static getZoomInfoSearchResults = async (params?: { q: string }) => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_ZOOMINFO_SEARCH_RESULTS.URL(), { params })
    ).data;
  };
  static getZoomInfoRecentSearch = async () => {
    return await (
      await axios.get(ApiConstants.BUSINESSES_API.GET_ZOOMINFO_SEARCH_RECENT.URL())
    ).data;
  };
  static addZoomInfoRecentSearch = async (payload: any) => {
    return await (
      await axios.post(ApiConstants.BUSINESSES_API.POST_ZOOMINFO_SEARCH_RECENT.URL(), payload)
    ).data;
  };
}
